export default "__VITE_ASSET__DyGmi9Xl__"